import img1 from '../images/product-item/item-1.jpg'
import img2 from '../images/product-item/item-2.jpg'
import img3 from '../images/product-item/item-3.jpg'
import img4 from '../images/product-item/item-4.jpg'
import imga1 from '../images/avatar/avt-7.jpg'
import imga2 from '../images/avatar/avt-13.jpg'
import imga3 from '../images/avatar/avt-14.jpg'
import imga4 from '../images/avatar/avt-15.jpg'

const dataLiveAution = [
    {
        img: img1,
        title: '3D Space Rocket With Smoke Premium',
        imgAuthor: imga1,
        name:'Daniel M.Bivens',
        price: '2 MATIC',
    },
    {
        img: img4,
        title: '3D Space Rocket With Smoke Premium',
        imgAuthor: imga4,
        name:'Daniel M.Bivens',
        price: '2 MATIC',
    },
    {
        img: img1,
        title: '3D Space Rocket With Smoke Premium',
        imgAuthor: imga1,
        name:'Daniel M.Bivens',
        price: '2 MATIC',
    },
    {
        img: img4,
        title: '3D Space Rocket With Smoke Premium',
        imgAuthor: imga4,
        name:'Daniel M.Bivens',
        price: '2 MATIC',
    },
]

export default dataLiveAution;